import * as core from '../../../../../../../core'

import { query } from './policy-explorer.query'

export const RESOURCE = {
  payload: {
    alias: 'policies:policy-explorer',
    content: {
      root: {
        elements: [
          {
            content: {
              widget: {
                widget: {
                  alias: 'policies.policy-explorer-table',
                },
              },
            },
            height: 800,
          },
        ],
      },
    },
    description:
      'Policy areas, drilling down to the policies within an area. The ' +
      'policyAreaId variable selects the area; null shows all areas.',
    name: 'Policy Explorer',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
